'use strict';

var _ = require('lodash');
var fieldMapping = require('./config/referenceMetricFieldMap.json');
var MetricReferenceDataService = function MetricReferenceDataService() {
  var referenceKeysMap = {
    lastYear: {
      CurrentReference: 'currentLastYear',
      FinalReference: 'finalLastYear'
    },
    referenceYear: {
      CurrentReference: 'currentReferenceYear',
      FinalReference: 'finalReferenceYear'
    },
    seasonalAverage: {
      CurrentReference: 'currentSeasonalAverage',
      FinalReference: 'finalSeasonalAverage'
    }
  };
  function mapFields(entry, fieldsMap) {
    return _.reduce(fieldsMap, function (result, path, fieldName) {
      result[fieldName] = _.get(entry, path);
      return result;
    }, {});
  }
  function getMetricsDataForGrid(entry, metrics) {
    return _.reduce(metrics, function (metricData, metricName) {
      metricData = _.extend(metricData, mapFields(entry, fieldMapping[metricName]));
      return metricData;
    }, {});
  }
  function getMetricValues(metricName, metricValues) {
    var result = {};
    var currentMetricValue = _.get(metricValues, ['current', metricName]);
    var expectedMetricValue = _.get(metricValues, ['expected', metricName]);
    if (!_.isNil(currentMetricValue)) {
      result[metricName + 'Current'] = currentMetricValue;
    }
    if (!_.isNil(expectedMetricValue)) {
      result[metricName + 'Expected'] = expectedMetricValue;
    }
    return result;
  }
  function getReferenceMetricValues(metricName, metricValues, referenceKeys) {
    var result = {};
    var currRefKey = referenceKeys.CurrentReference;
    if (currRefKey) {
      result[metricName + 'CurrentReference'] = _.get(metricValues, [currRefKey, metricName]);
    }
    var finalRefKey = referenceKeys.FinalReference;
    if (finalRefKey) {
      result[metricName + 'FinalReference'] = _.get(metricValues, [finalRefKey, metricName]);
    }
    return result;
  }
  function getMetricData(metricName, flowTypeMetrics, selectedReference) {
    var referenceKeys = referenceKeysMap[selectedReference] || referenceKeysMap.lastYear;
    var metricValues = getMetricValues(metricName, flowTypeMetrics);
    var referenceMetricValues = getReferenceMetricValues(metricName, flowTypeMetrics, referenceKeys);
    return _.merge(metricValues, referenceMetricValues);
  }
  function correctFieldNames(flowTypeMetrics) {
    _.forEach(flowTypeMetrics, function (metrics) {
      if (!_.isNil(metrics.bookings) && _.isNil(metrics.resHoldTotal)) {
        metrics.resHoldTotal = metrics.bookings;
      }
    });
    return flowTypeMetrics;
  }
  function getMetricsData(metricNames, flowTypeMetrics, selectedReference) {
    correctFieldNames(flowTypeMetrics);
    return _.reduce(metricNames, function (result, metricName) {
      var metricData = getMetricData(metricName, flowTypeMetrics, selectedReference);
      result = _.assign(result, metricData);
      return result;
    }, {});
  }
  return {
    getMetricsData: getMetricsData,
    getMetricsDataForGrid: getMetricsDataForGrid
  };
};
MetricReferenceDataService.$inject = [];
module.exports = MetricReferenceDataService;